import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import RootWorkplaceSettings from './RootWorkplaceSettings';

interface Props extends BaseModalProps {
	rootWorkplaceId: string;
}

const RootWorkplaceSettingsModal: React.FC<Props> = props => (
	<BaseModal title='component.rootWorkplaceSettings.modalTitle' {...props}>
		<RootWorkplaceSettings
			rootWorkplaceId={props.rootWorkplaceId}
			onSuccess={props.onClose}
		/>
	</BaseModal>
);

export default RootWorkplaceSettingsModal;
